import { useState } from "react";
import { useI18n } from "@wato/i18n/react";
import { Button } from "@wato/ui";
import { useUiLayer } from "./useUiLayer";
import { DemoConversation } from "./DemoConversation";
import { useOptionalWorkspace } from "../workspace/WorkspaceContext";

/**
 * UXR-23: the existing try-without-WhatsApp demo as a secondary button («جرّب العرض») that opens the
 * simulated conversation in place. Used on Home (no channel yet) and in the empty inbox.
 */
export function TryDemoPanel({ workspaceId }: { readonly workspaceId: string }) {
  const { t } = useI18n();
  const workspace = useOptionalWorkspace()?.workspace;
  const [open, setOpen] = useState(false);
  const demo = useUiLayer(workspaceId, "demoConversation");
  return (
    <div className="flex flex-col gap-3" data-testid="try-demo">
      {open ? (
        <DemoConversation
          workspaceId={workspaceId}
          businessName={workspace?.name ?? ""}
          onTried={() => demo.show && demo.dismiss()}
          onClose={() => setOpen(false)}
        />
      ) : (
        <Button variant="secondary" onClick={() => setOpen(true)}>
          {t("setup.checklist.steps.tryDemo.cta")}
        </Button>
      )}
    </div>
  );
}
